import { FC } from 'react';

import type { FieldRendererProps } from '../../../Info/fields/Fields.types';
import { PlainFieldRenderer } from '../../../Info/fields/PlainFieldRenderer';
import { Items } from '../Items';

/** Kit fields with their own component (`items`, a count); the rest render plain. */
export const FieldRenderer: FC<FieldRendererProps> = ({ field, ...options }) =>
	field.id === 'items' ? <Items /> : <PlainFieldRenderer field={field} {...options} />;
